import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import type { CustomIcons } from "./Icons.type";

const WorkoutsIcons: CustomIcons = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3334 12.5V4.50003C13.3334 3.39546 12.4379 2.50003 11.3334 2.50003H10.3704H5.62965H4.66669C3.56212 2.50003 2.66669 3.39546 2.66669 4.50003V12.5C2.66669 13.6046 3.56212 14.5 4.66669 14.5H11.3334C12.4379 14.5 13.3334 13.6046 13.3334 12.5Z"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <path d="M7.33337 6.83334H10.6667" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <path d="M7.33337 10.1667H10.6667" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <circle cx="5.36844" cy="6.86844" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="0.403509" />
      <circle cx="5.36844" cy="10.2018" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="0.403509" />
      <rect x="5.5" y="1.5" width="5" height="2" rx="1" fill="currentColor" />
    </svg>
  ),
  medium: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 19.75V5.75003C20 4.64546 19.1046 3.75003 18 3.75003H15.5556H8.44444H6C4.89543 3.75003 4 4.64546 4 5.75003V19.75C4 20.8546 4.89543 21.75 6 21.75H18C19.1046 21.75 20 20.8546 20 19.75Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path d="M11 10.25H16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M11 15.25H16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="8.05263" cy="10.3027" r="0.552632" fill="currentColor" stroke="currentColor" />
      <circle cx="8.05263" cy="15.3027" r="0.552632" fill="currentColor" stroke="currentColor" />
      <rect x="8.25" y="2.25" width="7.5" height="3" rx="1" fill="currentColor" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.6666 27.0001V7.00006C26.6666 5.89549 25.7712 5.00006 24.6666 5.00006H20.7407H11.2592H7.33331C6.22874 5.00006 5.33331 5.89549 5.33331 7.00006V27.0001C5.33331 28.1046 6.22875 29.0001 7.33332 29.0001H24.6666C25.7712 29.0001 26.6666 28.1046 26.6666 27.0001Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M14.6666 13.6667H21.3333" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M14.6666 20.3334H21.3333" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="10.7333" cy="13.7334" r="0.9" fill="currentColor" stroke="currentColor" />
      <circle cx="10.7333" cy="20.4001" r="0.9" fill="currentColor" stroke="currentColor" />
      <rect x="11" y="3" width="10" height="4" rx="1" fill="currentColor" />
    </svg>
  ),
};

function WorkoutsIcon(props: SvgIconProps) {
  const { fontSize } = props;

  const fSize = fontSize !== "inherit" ? fontSize : "medium";
  const content = WorkoutsIcons[fSize || "medium"];

  return <SvgIcon {...props}>{content}</SvgIcon>;
}
export default WorkoutsIcon;
